webpackJsonp([40151897784040],{

/***/ 487:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Elasticsearch and Kibana are pretty popular way to store, visualise and analyze data from your application. In this post I want to provide a fast and easy guide how to setup Elasticsearch and Kibana on Docker. I will not go deep with each parameter…","frontmatter":{"title":"How to instal Elasticsearch and Kibana on Docker","date":"2020-04-13T00:00:00.000Z","path":"/how-to-install-elastic-search-and-kibana"}}}]}},"pathContext":{"siteTitle":"Martin Vích's blog","tagName":"Kibana","name":"Kibana"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-kibana-68331dc3acaed4162892.js